import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWarningOrange = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1024 1024",
	fill: "none",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M512 0c-282.624 0-512 229.376-512 512s229.376 512 512 512c282.624 0 512-229.376 512-512s-229.376-512-512-512zM563.2 716.8c0 28.278-22.922 51.2-51.2 51.2s-51.2-22.922-51.2-51.2c0-28.278 22.923-51.2 51.2-51.2s51.2 22.922 51.2 51.2zM563.2 512c0 28.278-22.922 51.2-51.2 51.2s-51.2-22.922-51.2-51.2v-204.8c0-28.277 22.923-51.2 51.2-51.2s51.2 22.923 51.2 51.2v204.8z",
		fill: "rgb(242, 153, 74)"
	})
});
const ForwardRef = forwardRef(SvgWarningOrange);
export default ForwardRef;
